import { UserResponse, UsersRequest, UserWallet } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { ApiVersions } from '../../../enums';
import { env } from '../../../environment';

class UserController extends BaseApiService {

  public async getWallet(): Promise<UserWallet> {
    const url = `${this.url}/api/${ApiVersions.V1}/user/wallet`;
    return await this.http.get(url);
  }

  public async getUsers(params: UsersRequest): Promise<UserResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/user`;
    return await this.http.get(url, { params });
  }

}

export const userController = new UserController({ url: env.httpUrl });
